<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eYT1o6/tc-custom/9781399062633.jpg?1733037289509" alt="This image is the cover for the book Churchill as Home Secretary"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Churchill as Home Secretary
      </h1>
      <p class="bookDescription body article font2">
        <p>There can be few statesmen whose lives and careers have received as much investigation and literary attention as Winston Churchill. Relatively little however has appeared which deals specifically or holistically with his first senior ministerial role; that of Secretary of State for the Home Office. This may be due to the fact that, of the three Great Offices of State which he was to occupy over the course of his long political life, his tenure as Home Secretary was the briefest.  The Liberal Government, of which he was a senior figure, had been elected in 1906 to put in place social and political reform. Though Churchill was at the forefront of these matters, his responsibility for domestic affairs led to him facing other, major, challenges departmentally; this was a time of substantial commotion on the social front, with widespread industrial and civil strife. Even given that ‘Home Secretaries never do have an easy time’, his period in office was thus marked by a huge degree of political and social turbulence. The terms ‘Tonypandy’ and ‘Peter the Painter’ perhaps spring most readily to mind. Rather less known is his involvement in one of the burning issues of the time, female suffrage, and his portrayal as ‘the prisoners’ friend’ in terms of penal reform.  Aged 33 on appointment, and the youngest Home Secretary since 1830, he became empowered to wield the considerable executive authority inherent in the role of one of His Majesty's Principal Secretaries of State, and he certainly did not shrink from doing so. There were of course commensurate responsibilities, and how he shouldered them is worth examination.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles Stephenson
      </h2>
      
      <p class="authorDescription body article">Charles Stephenson is an established author on naval and siege warfare and the history of fortifications, with the following books in print: The Fortifications of Malta 1530-1945, Zeppelins: German Airships 1900-40, The Channel Islands 1941-45: Hitler's Impregnable Fortress, The Admirals Secret Weapon: Lord Dundonald and the Origins of Chemical Warfare and Germanys Asia-Pacific Empire: Colonialism and Naval Policy, 1885-1914. He was Consultant Editor and a contributor to Castles: A History of Fortified Structures: Ancient, Medieval & Modern. He is also the creator of the three books that (thus far) constitute the Samson Plews Collection.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e4d508e6